<div class="w-full bg-white shadow-sm relative" (click)="isExportDropdownOpen = false">

  <!-- Loading overlay -->
  <div *ngIf="isLoading"
    class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white opacity-75 flex flex-col items-center justify-center">
    <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-indigo-500 !important"></div>
  </div>

  <!-- Error card -->
  <div *ngIf="showErrorCard" class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
    (click)="closeErrorCard()">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full relative" (click)="$event.stopPropagation()">
      <button (click)="closeErrorCard()" class="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div class="text-center">
        <svg class="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 class="mt-2 text-lg font-medium text-gray-900">{{ errorTitle }}</h3>
        <p class="mt-1 text-sm text-gray-500">{{ errorMessage }}</p>
      </div>
      <div class="mt-5">
        <button (click)="refreshTrend()"
          class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
          Try Again
        </button>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && chartData.length <= 1"
    class="absolute flex items-center justify-center bg-white" style="top: 120px; left: 0; right: 0; bottom: 0;">
    <div class="text-center">
      <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
      </svg>
      <h3 class="mt-2 text-lg font-medium text-gray-900">No data available</h3>
      <p class="mt-1 text-sm text-gray-500">No records extracted for the selected scope.</p>
    </div>
  </div>

  <div class="w-full !important">
    <div class="w-full !important" [ngClass]="{ 'opacity-50': isLoading }">
      <section class="border-collapse pb-3 mt-2 h-full bg-white shadow-sm !important">

        <!-- Toolbar -->
        <div class="flex items-center justify-between gap-2 mb-1 px-4 py-2 bg-white border-collapse !important" style="width:100%;">

          <!-- Left: practice filter + endpoint filter + apply -->
          <div class="flex items-center gap-2 flex-shrink-0">
            <div class="relative inline-block text-left select-filter-menu" (click)="$event.stopPropagation()">
              <div class="audit-report-dropdown" appClickOutsideDirective (appClickOutside)="closePracticeDropdown()">

                <button type="button"
                  class="inline-flex justify-between w-44 border border-gray-300 px-2 py-1 bg-white text-sm text-gray-700 hover:bg-gray-50 focus:outline-none rounded"
                  (click)="togglePracticeDropdown()">
                  <span class="truncate regular-font">
                    <ng-container *ngIf="allPracticesSelected">Practices: <strong>All</strong></ng-container>
                    <ng-container *ngIf="!allPracticesSelected">Practices:
                      <strong>{{ selectedPracticeIds.length }} selected</strong></ng-container>
                  </span>
                  <svg class="-mr-1 ml-2 h-5 w-5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M10 12a1 1 0 01-.707-.293l-4-4a1 1 0 111.414-1.414L10 9.586l3.293-3.293a1 1 0 011.414 1.414l-4 4A1 1 0 0110 12z"
                      clip-rule="evenodd" />
                  </svg>
                </button>

                <div
                  class="origin-top-left absolute left-0 z-50 top-full mt-1 w-64 shadow-lg bg-white ring-1 ring-black ring-opacity-5 flex flex-col max-h-[350px]"
                  [ngClass]="{ hidden: !isPracticeDropdownOpen }">
                  <!-- Search -->
                  <div class="px-3 py-2 border-b border-gray-100 flex-shrink-0">
                    <div class="relative">
                      <div class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                        <svg class="w-3 h-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                          viewBox="0 0 20 20">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                      </div>
                      <input type="text" [(ngModel)]="practiceSearchQuery"
                        class="block w-full py-1 pl-7 pr-2 text-sm text-gray-900 border border-gray-300 rounded bg-gray-50 focus:ring-indigo-500 focus:border-indigo-500"
                        placeholder="Search practices..." (click)="$event.stopPropagation()" />
                    </div>
                  </div>
                  <div class="py-1 overflow-auto flex-1" role="menu">
                    <!-- All option -->
                    <div class="px-4 py-2 border-b border-gray-100">
                      <label class="inline-flex items-center w-full cursor-pointer select-none">
                        <input type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600"
                          [checked]="tempAllPracticesSelected"
                          (change)="onAllPracticesToggle($any($event.target).checked)" />
                        <span class="ml-2 regular-font text-gray-700 font-semibold">All practices</span>
                      </label>
                    </div>
                    <!-- Individual practices -->
                    <div class="px-4 py-2" *ngFor="let practice of filteredPracticeOptions">
                      <label class="inline-flex items-center w-full cursor-pointer select-none">
                        <input type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600"
                          [checked]="tempAllPracticesSelected || isPracticeSelected(practice.id)"
                          (change)="onPracticeToggle(practice.id, $any($event.target).checked)" />
                        <span class="ml-2 regular-font text-gray-700 truncate">{{ practice.name }}</span>
                      </label>
                    </div>
                    <div *ngIf="filteredPracticeOptions.length === 0"
                      class="px-4 py-3 text-sm text-gray-400 regular-font">
                      No practices found.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Endpoint filter -->
            <div *ngIf="practiceOptions.length > 0"
              class="relative inline-block text-left select-filter-menu" (click)="$event.stopPropagation()">
              <div class="audit-report-dropdown" appClickOutsideDirective (appClickOutside)="closeEndpointDropdown()">
                <button type="button"
                  class="inline-flex justify-between w-52 border border-gray-300 px-2 py-1 bg-white text-sm text-gray-700 hover:bg-gray-50 focus:outline-none rounded"
                  (click)="toggleEndpointDropdown()" [disabled]="isEndpointLoading">
                  <span class="truncate regular-font">
                    <ng-container *ngIf="allEndpointsSelected">Endpoints: <strong>All</strong></ng-container>
                    <ng-container *ngIf="!allEndpointsSelected">Endpoints:
                      <strong>{{ selectedEndpointIds.length }} selected</strong></ng-container>
                  </span>
                  <svg class="-mr-1 ml-2 h-5 w-5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 12a1 1 0 01-.707-.293l-4-4a1 1 0 111.414-1.414L10 9.586l3.293-3.293a1 1 0 011.414 1.414l-4 4A1 1 0 0110 12z" clip-rule="evenodd" />
                  </svg>
                </button>

                <div class="origin-top-left absolute left-0 z-50 top-full mt-1 w-64 shadow-lg bg-white ring-1 ring-black ring-opacity-5 flex flex-col max-h-[350px]"
                  [ngClass]="{ hidden: !isEndpointDropdownOpen }">
                  <!-- Search -->
                  <div class="px-3 py-2 border-b border-gray-100 flex-shrink-0">
                    <div class="relative">
                      <div class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                        <svg class="w-3 h-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                          viewBox="0 0 20 20">
                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                      </div>
                      <input type="text" [(ngModel)]="endpointSearchQuery"
                        class="block w-full py-1 pl-7 pr-2 text-sm text-gray-900 border border-gray-300 rounded bg-gray-50 focus:ring-indigo-500 focus:border-indigo-500"
                        placeholder="Search endpoints..." (click)="$event.stopPropagation()" />
                    </div>
                  </div>
                  <div class="py-1 overflow-auto flex-1" role="menu">
                    <!-- All endpoints option -->
                    <div class="px-4 py-2 border-b border-gray-100">
                      <label class="inline-flex items-center w-full cursor-pointer select-none">
                        <input type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600"
                          [checked]="tempAllEndpointsSelected"
                          (change)="onAllEndpointsToggle($any($event.target).checked)" />
                        <span class="ml-2 regular-font text-gray-700 font-semibold">All endpoints</span>
                      </label>
                    </div>
                    <!-- Individual endpoints -->
                    <div class="px-4 py-2" *ngFor="let ep of filteredEndpointOptions">
                      <label class="inline-flex items-center w-full cursor-pointer select-none">
                        <input type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600"
                          [checked]="tempAllEndpointsSelected || isEndpointSelected(ep.endpoint)"
                          (change)="onEndpointToggle(ep.endpoint, $any($event.target).checked)" />
                        <span class="ml-2 regular-font text-gray-700 truncate">{{ ep.displayName }}</span>
                      </label>
                    </div>
                    <div *ngIf="filteredEndpointOptions.length === 0 && !isEndpointLoading"
                      class="px-4 py-3 text-sm text-gray-400 regular-font">No endpoints found.</div>
                    <div *ngIf="isEndpointLoading" class="px-4 py-3 text-sm text-gray-400 regular-font">Loading...</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Apply Filters button -->
            <button
              class="inline-flex items-center gap-1 px-3 py-1.5 text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 regular-font text-sm rounded"
              (click)="applyAllFilters()">
              Apply Filters
            </button>

            <!-- Reset Filter button -->
            <button *ngIf="hasActiveFilters"
              class="inline-flex items-center ring-offset-1 text-white bg-indigo-500 ring-gray-300 focus:outline-none hover:bg-indigo-400 focus:ring-2 focus:ring-indigo-500 regular-font px-3 py-1.5"
              (click)="resetFilters()">
              <span class="mr-1">Reset Filter</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18" viewBox="0 0 32 32">
                <path d="M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z"/>
                <path d="M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z"/>
              </svg>
            </button>

          </div>

          <!-- Right: summary + refresh -->
          <div class="flex items-center gap-2" style="flex-shrink:0;">
            <!-- Practices scope badge -->
            <div class="scope-badge relative group cursor-default ring-inset bg-gray-50 py-1.5 regular-font rounded-sm px-2 ring-1 ring-gray-300">
              <span class="scope-badge-text">{{ practiceBadgeLabel }}</span>
              <div *ngIf="!allPracticesSelected && selectedPracticeNames.length > 0"
                class="absolute bottom-full left-0 mb-1 hidden group-hover:block z-50 bg-gray-800 text-white text-xs rounded py-1.5 px-2"
                style="white-space:nowrap;">
                <div *ngFor="let name of selectedPracticeNames">{{ name }}</div>
              </div>
            </div>
            <!-- Endpoints scope badge -->
            <div class="scope-badge relative group cursor-default ring-inset bg-gray-50 py-1.5 regular-font rounded-sm px-2 ring-1 ring-gray-300">
              <span class="scope-badge-text">{{ endpointBadgeLabel }}</span>
              <div *ngIf="!allEndpointsSelected && selectedEndpointNames.length > 0"
                class="absolute bottom-full left-0 mb-1 hidden group-hover:block z-50 bg-gray-800 text-white text-xs rounded py-1.5 px-2"
                style="white-space:nowrap;">
                <div *ngFor="let name of selectedEndpointNames">{{ name }}</div>
              </div>
            </div>
            <div class="flex ring-inset bg-gray-50 py-1.5 regular-font rounded-sm px-2 ring-1 ring-gray-300">
              <span class="regular-font">Days: </span>&nbsp;{{ totalDays }}
            </div>
            <div class="flex ring-inset bg-gray-50 py-1.5 regular-font rounded-sm px-2 ring-1 ring-gray-300">
              <span class="regular-font">Total: </span>&nbsp;{{ totalRecordsFormatted }} records
            </div>
            <!-- Day-over-day toggle -->
            <button
              class="inline-flex items-center gap-1.5 ring-offset-1 ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 regular-font px-3 py-1.5 border"
              [ngClass]="showDayOverDayChange ? 'text-white bg-indigo-500 hover:bg-indigo-400 border-transparent' : 'text-gray-600 bg-white hover:bg-gray-50 border-gray-300'"
              (click)="toggleDayOverDay()" title="Toggle day-over-day change labels">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
              </svg>
              <span>{{ showDayOverDayChange ? 'Daily Variance: On' : 'Daily Variance: Off' }}</span>
            </button>
            <!-- Refresh button -->
            <button
              class="inline-flex items-center ring-offset-1 text-white bg-indigo-500 ring-gray-300 focus:outline-none hover:bg-indigo-400 focus:ring-2 focus:ring-indigo-500 regular-font px-3 py-1.5"
              (click)="refreshTrend()">
              <span class="mr-1">Refresh</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-4 h-4">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Chart -->
        <div class="px-4 pb-4" *ngIf="!isLoading && chartData.length > 1">
          <app-chart #trendChart [chartConfig]="chartConfig" [data]="chartData"></app-chart>
        </div>

        <!-- Data Table -->
        <div class="px-4 pb-4" *ngIf="!isLoading && tableData.length > 0">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-gray-600 regular-font">Load Volume Details</span>
            <div class="relative" (click)="$event.stopPropagation()">
              <button (click)="isExportDropdownOpen = !isExportDropdownOpen"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded border border-gray-300 bg-indigo-600 text-white regular-font hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Export
              </button>
              <div *ngIf="isExportDropdownOpen"
                class="absolute right-0 mt-1 w-44 bg-white border border-gray-200 rounded shadow-lg z-10">
                <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer"
                  (click)="exportTableData(); isExportDropdownOpen = false">Export to Excel</a>
                <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer"
                  (click)="exportToPDF(); isExportDropdownOpen = false">Export to PDF</a>
              </div>
            </div>
          </div>
          <div class="overflow-auto border border-gray-200">
            <table class="min-w-full text-sm regular-font">
              <thead class="bg-violet-100">
                <tr>
                  <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase whitespace-nowrap">Load Date</th>
                  <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase whitespace-nowrap">Practice</th>
                  <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase whitespace-nowrap">Endpoint</th>
                  <th class="px-4 py-2 text-right text-xs font-medium text-gray-700 uppercase whitespace-nowrap">Records Extracted</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of tableData; let odd = odd" [ngClass]="odd ? 'bg-gray-50' : 'bg-white'" class="hover:bg-slate-100">
                  <td class="px-4 py-2 whitespace-nowrap">{{ row.loadDate }}</td>
                  <td class="td-truncate px-4 py-2" [title]="row.practice">{{ row.practice }}</td>
                  <td class="td-truncate px-4 py-2" [title]="row.endpoint">{{ row.endpoint }}</td>
                  <td class="px-4 py-2 whitespace-nowrap text-right">{{ row.loadCount | number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </section>
    </div>
  </div>
</div>

<app-toast></app-toast>
